import * as React from 'react';
import * as Styled from './Footer.styled';
export function Footer(
// eslint-disable-next-line @typescript-eslint/ban-types
props) {
    return React.createElement(Styled.FooterRoot, null, props.children);
}
//# sourceMappingURL=Footer.js.map